<section class="wrap-blog">
  <div class="layout">
    <h2 class="subtitle">Blog</h2>
    <p>Confira o conteúdo mais atualizado do mercado veicular.</p>
  </div>
  <div class="layout no-padding-mobile">
    <div class="list-posts slick-initialized slick-slider">
      <div class="slick-list draggable">
        <div class="slick-track" style="opacity: 1; transform: translate3d(0px, 0px, 0px);">
          <div *ngFor="let post of posts" class="slick-slide slick-current slick-active"
            [attr.data-slick-index]="posts.indexOf(post)" aria-hidden="false" style="width: 385px;">
            <div>
              <a class="post" [id]="post.id" href="/blog/{{post.id}}/{{post.slug}}/" tabindex="0"
                style="width: 100%; display: inline-block;">
                <div class="photo" [ngStyle]="{'background-image': 'url(' + post.link_img + ')'}"></div>
                <div class="infos">
                  <h2 class="post-title">{{ post.titulo }}</h2>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>